export default "__VITE_ASSET__BumcUwTK__"